import { render, staticRenderFns } from "./page-other-owner.vue?vue&type=template&id=1788a4a2&scoped=true&"
import script from "./page-other-owner.vue?vue&type=script&lang=js&"
export * from "./page-other-owner.vue?vue&type=script&lang=js&"
import style0 from "./page-other-owner.vue?vue&type=style&index=0&id=1788a4a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1788a4a2",
  null
  
)

component.options.__file = "page-other-owner.vue"
export default component.exports